<template>
  <v-flex class="about">
    <v-layout>
      <h1>Meeting Rooms</h1>
      <v-spacer />
      <v-btn color="primary" dark to="/meeting-rooms/bookings-calendar">
        Calendar <v-icon small right>calendar_today</v-icon>
      </v-btn>
      <v-dialog v-model="addRoomDialog" persistent max-width="600px">
        <template v-slot:activator="{ on: dialog }">
          <v-btn class="ml-3" color="success" dark v-on="{ ...dialog }">
            Add Room <v-icon right>add</v-icon>
          </v-btn>
        </template>
        <add-room v-if="addRoomDialog" @close="addRoomDialog = false" />
      </v-dialog>
    </v-layout>
    <v-card>
      <v-list v-if="loaded" two-line class="mt-3 pt-0 pb-0">
        <template v-for="(room, index) in meetingRooms">
          <v-list-item :key="room.id">
            <v-list-item-avatar> <v-icon>work</v-icon> </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title>{{ room.name }}</v-list-item-title>
              <v-list-item-subtitle>
                {{ room.description }}
              </v-list-item-subtitle>
            </v-list-item-content>

            <v-list-item-action>
              <v-menu
                bottom
                left
                transition="slide-y-transition"
                min-width="150"
              >
                <template v-slot:activator="{ on: menu }">
                  <v-btn icon v-on="{ ...menu }">
                    <v-icon>more_vert</v-icon>
                  </v-btn>
                </template>
                <v-list dense>
                  <v-list-item @click="goToBookings(room.id, room.name)">
                    <v-icon class="mr-2">access_time</v-icon>
                    <v-list-item-title>Bookings</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="openEditRoomDialog(room)">
                    <v-icon class="mr-2">edit</v-icon>
                    <v-list-item-title>Edit</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="openDeleteDialog(room)">
                    <v-icon class="mr-2">delete</v-icon>
                    <v-list-item-title>Delete</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-list-item-action>
          </v-list-item>
          <v-divider
            v-if="index + 1 < meetingRooms.length"
            :key="index"
          ></v-divider>
        </template>
      </v-list>
      <v-alert
        v-if="meetingRooms.length === 0 && loaded"
        :value="true"
        type="info"
        color="primary"
        outlined
      >
        There are no meeting rooms to display
      </v-alert>
    </v-card>

    <v-progress-linear
      v-if="!loaded"
      color="info"
      :indeterminate="true"
      class="mt-3"
    />

    <v-dialog v-model="deleteDialog" persistent max-width="290">
      <v-card>
        <v-app-bar flat dark color="primary">
          <v-toolbar-title>Are you sure?</v-toolbar-title>
        </v-app-bar>
        <v-card-text>
          If you delete this room it will be gone forever.
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="grey" text @click="deleteDialog = false">Cancel</v-btn>
          <v-btn color="error" :loading="loadingDelete" @click="deleteRoom()"
            >Delete</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="editRoomDialog" persistent max-width="600px">
      <add-room
        v-if="editRoomDialog"
        :key="currentRoom.id"
        :edit="currentRoom"
        @close="editRoomDialog = false"
      />
    </v-dialog>
  </v-flex>
</template>

<script>
import { roomsCollection } from '../firebaseConfig.js';
import AddRoom from '@/components/AddRoom';

export default {
  name: 'MeetingRooms',
  components: {
    AddRoom
  },
  data() {
    return {
      loaded: false,
      meetingRooms: [],
      addRoomDialog: false,
      editRoomDialog: false,
      deleteDialog: false,
      currentRoom: null,
      loadingDelete: false
    };
  },
  computed: {
    currentLocationId() {
      return this.$store.state.currentLocation.id;
    }
  },
  mounted() {
    this.$bind(
      'meetingRooms',
      roomsCollection(this.currentLocationId).orderBy('name')
    )
      .then(() => {
        this.loaded = true;
      })
      .catch(error => {
        this.$store.dispatch('createSnackbar', {
          color: 'error',
          text: `Error loading rooms: ${error}`
        });
      });
  },
  methods: {
    goToBookings(roomid, roomname) {
      this.$router.push({
        name: 'bookings',
        params: { roomid, roomname }
      });
    },
    openDeleteDialog(room) {
      this.currentRoom = room;
      this.deleteDialog = true;
    },
    openEditRoomDialog(room) {
      this.currentRoom = room;
      this.editRoomDialog = true;
    },
    deleteRoom() {
      this.loadingDelete = true;
      roomsCollection(this.currentLocationId)
        .doc(this.currentRoom.id)
        .delete()
        .then(() => {
          this.deleteDialog = false;
          this.$store.dispatch('createSnackbar', {
            color: 'success',
            text: `Room deleted successfully: ${this.currentRoom.name}`
          });
        })
        .catch(error => {
          this.deleteDialog = false;
          this.$store.dispatch('createSnackbar', {
            color: 'error',
            text: `Error deleting room: ${error}`
          });
        })
        .finally(() => {
          this.loadingDelete = false;
        });
    }
  }
};
</script>
